export const createRefreshQueue = () => {
  let subscribers = [];

  return {
    add(resolve, reject) {
      subscribers.push({ resolve, reject });
    },
    resolve(value) {
      const pending = subscribers;
      subscribers = [];
      pending.forEach(({ resolve }) => resolve(value));
    },
    reject(error) {
      const pending = subscribers;
      subscribers = [];
      pending.forEach(({ reject }) => reject(error));
    },
  };
};
